import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import CloseSvg from '@assets/images/icons/v2/close.svg'
import { SubTitle, Title } from '@/modules/base/components/texts'

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.white,
    borderBottom: `1px solid ${theme.borderColor}`,
    display: 'flex',
    flexDirection: 'column',
  },
  icon: {
    fill: theme.Panel.header.controls.color,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'relative',
  },
  closeButton: {
    border: 0,
    backgroundColor: 'transparent',
    padding: 17,
    outline: 'none',
    display: 'flex',
    alignSelf: 'center',
  },
  hiddenCloseButton: {
    padding: '17px 0',
  },
  title: {
    fontSize: '22px',
    margin: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '110px',
    marginLeft: 30,
  },
}))

const PanelHeader = (props) => {
  const {
    displayClose = false,
    onClose = () => {},
    customClose,
    title,
    subtitle,
    children,
    toolbarRender,
    className,
  } = props
  const classes = useStyles()
  const iconSize = '10px'
  const doDisplayTitle = title || subtitle

  const closeButton = customClose ?? (
    <button type="button" onClick={onClose} className={classes.closeButton}>
      <SVGIcon svg={CloseSvg} height={iconSize} width={iconSize} customClass={classes.icon} />
    </button>
  )

  return (
    <header className={clsx(classes.root, className)}>
      <div className={classes.toolbar}>
        {toolbarRender && toolbarRender()}
        {displayClose
          ? (closeButton)
          : (<div className={clsx(classes.closeButton, classes.hiddenCloseButton)} />)}
      </div>
      {doDisplayTitle && <div className={classes.titleContainer}>
        {title && <Title className={classes.title} position="center">{title}</Title>}
        {subtitle && <SubTitle position="center">{subtitle}</SubTitle>}
      </div>}
      {children}
    </header>
  )
}

PanelHeader.propTypes = {
  displayClose: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  className: PropTypes.string,
  toolbarRender: PropTypes.func,
  children: PropTypes.node,
}

export default PanelHeader
